(function() { window.GUID_9bc03b47_eff5_4db9_a1ca_20db715c9d6e = { getGuid: function() { return "9bc03b47-eff5-4db9-a1ca-20db715c9d6e"; } }; })();
var CS;
(function (CS) {
    class TextBox {
        constructor(inputBox) {
            this.TextBox = $(inputBox);
            this.TextBoxId = this.TextBox[0].id;
            this.SetEvents();
        }
        SetStyle() {
        }
        SetEvents() {
            let me = this;
            if (me.TextBox.data('autocompleteurl') == null) {
                $(me.TextBox).off('change');
                $(me.TextBox).on('change', function () {
                    me.TextBox.trigger("CSChange", me);
                }).on('keyup', function (e) {
                    if (e.keyCode == 9 || //TAB
                        e.keyCode == 16 || //SHIFT
                        e.keyCode == 17 || //CTRL
                        e.keyCode == 18 || //ALT
                        e.keyCode == 20 || //CAPS LOCK
                        e.keyCode == 37 || //LEFT ARROW
                        e.keyCode == 38 || //UP ARROW
                        e.keyCode == 39 || //RIGHT ARROW
                        e.keyCode == 40 || //DOWN ARROW
                        e.keyCode == 45 || //INSERT
                        e.keyCode == 144 || //NUM LOCK
                        e.keyCode == 67 ||
                        e.keyCode == 65) {
                        return;
                    }
                    me.TextBox.trigger("CSChange", me);
                });
            }
            $(me.TextBox).off("mouseup");
            $(me.TextBox).on("mouseup", function (e) {
                var actualTextBox = $(this);
                var oldValue = actualTextBox.val();
                if (oldValue == "") {
                    return;
                }
                setTimeout(function () {
                    var newValue = actualTextBox.val();
                    if (newValue == "") {
                        me.TextBox.trigger("CSClear");
                    }
                }, 1); // sert à contourner un problème avec le bouton (x) d'une inputBox
            });
        }
    }
    CS.TextBox = TextBox;
})(CS || (CS = {}));
/*
(function ($) {
    $.fn.CSTextBox = function () {
        this.each(function () {
 
            var textbox = new CS.TextBox($(this));
    
        });
    };
})(jQuery);


var CS = CS || {};

CS.TextBox = function (inputBox) {

    this.TextBox = $(inputBox);
    this.TextBoxId = this.TextBox[0].id;
    this.SetEvents();
};

CS.TextBox.prototype = function () {

    var SetStyle = function () {

    },
    SetEvents = function () {
        var me = this;
       
        if (me.TextBox.data('autocompleteurl') == null)
        {
            $(me.TextBox).off('change');
            $(me.TextBox).on('change', function () {

                me.TextBox.trigger("CSChange", me);

            }).on('keyup', function (e) {
                if (e.keyCode == 9 || //TAB
                    e.keyCode == 16 || //SHIFT
                    e.keyCode == 17 || //CTRL
                    e.keyCode == 18 || //ALT
                    e.keyCode == 20 || //CAPS LOCK
                    e.keyCode == 37 || //LEFT ARROW
                    e.keyCode == 38 || //UP ARROW
                    e.keyCode == 39 || //RIGHT ARROW
                    e.keyCode == 40 || //DOWN ARROW
                    e.keyCode == 45 || //INSERT
                    e.keyCode == 144 || //NUM LOCK
                    e.keyCode == 67 ||
                    e.keyCode == 65
                    )
                {
                    return;
                }
                    
                me.TextBox.trigger("CSChange", me);

            });
        }

        $(me.TextBox).off("mouseup");
        $(me.TextBox).on("mouseup", function (e) {
            var actualTextBox = $(this);
            var oldValue = actualTextBox.val();

            if (oldValue == "") return;
 
            setTimeout(function () {
                var newValue = actualTextBox.val();

                if (newValue == "") {
                    me.TextBox.trigger("CSClear");
                }
            }, 1);
        });
        me.TextBox.val = function () {
            return "123";
        };
    };
    return {
        SetStyle: SetStyle,
        SetEvents: SetEvents
    };

}();
*/ 

//# sourceMappingURL=cs.textbox.js.map
